import { storeEmailForSignIn } from "@/auth/emailStorage";
import { requestSignInLink } from "@/firebase/callables";
import { firebaseAuth } from "@/firebase/client";
import { Platform } from "react-native";
import {
  createLoginRequestDetails,
  storeCurrentLoginRequestId
} from "@/auth/loginRequest";
import type { RequestSignInLinkResponse } from "@recital-master/shared";

export function signInRateLimitCopy(retryAfterSeconds: number): string {
  const minutes = Math.max(1, Math.ceil(retryAfterSeconds / 60));
  const wait =
    minutes >= 60
      ? "about an hour"
      : `${minutes} minute${minutes === 1 ? "" : "s"}`;
  return `You’ve reached the limit of 10 sign-in emails per hour. Please try again in ${wait}.`;
}

export async function sendEmailSignInLink(email: string): Promise<RequestSignInLinkResponse> {
  const trimmedEmail = email.trim().toLowerCase();

  if (!trimmedEmail) {
    throw new Error("Email is required.");
  }

  if (!firebaseAuth) {
    throw new Error("Firebase client config is missing.");
  }

  const request = await createLoginRequestDetails();
  const response = await requestSignInLink(
    trimmedEmail,
    Platform.OS === "web" ? "web" : "native",
    request
  );
  if (response.status === "rate-limited") return response;
  await storeEmailForSignIn(trimmedEmail);
  await storeCurrentLoginRequestId(response.requestId);
  return response;
}
